import InventarioService from 'src/modules/inventario/inventarioService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'INVENTARIO_VIEW';

const inventarioViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: inventarioViewActions.FIND_STARTED,
      });

      const record = await InventarioService.find(id);

      dispatch({
        type: inventarioViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: inventarioViewActions.FIND_ERROR,
      });

      getHistory().push('/inventario');
    }
  },
};

export default inventarioViewActions;
